export default __webpack_public_path__ + "static/media/emotionDecH1.46c46602.png";